import styled from 'styled-components';
import { ChatRowWrapper } from '@guuru/react-chat-messages';

export default styled(ChatRowWrapper)`
  background-color: ${({ $transparent }) => ($transparent ? 'transparent' : 'white')};
  border-top: ${({ button }) => (button ? 'inherit' : '1px solid rgb(230, 230, 230)')};
  border-radius: ${({ button }) => (button ? '8px' : 'inherit')};
  padding: 0 1rem;
`;
